<template>
  <div class="home">
    <TalkerWindow msg="Začněte šifrovaně chatovat"/>
  </div>
</template>

<script>
// @ is an alias to /src
import TalkerWindow from '@/components/TalkerWindow.vue'

export default {
  name: 'TalkerView',
  components: {
    TalkerWindow
  },
  methods: {

  },

  
}
</script>
